import dayjs from 'dayjs'

function validMoments(startMoment, endMoment) {
  return startMoment.isValid() && endMoment.isValid()
}

function validRange(startMoment, endMoment, sameIsValid) {
  if (dayjs(startMoment).isSame(dayjs(endMoment))) {
    if (!sameIsValid) {
      return 'equal'
    }
    return null
  }
  return dayjs(startMoment).isBefore(dayjs(endMoment)) ? 'lesser' : 'greater'
}

function generateTimeIncrement(minIncrementProp) {
  // Create an array of all possible times that can be selected
  const minuteIncrement = 60 / minIncrementProp
  const timeArray = []
  for (let i = 0; i <= 24; i++) {
    // eslint-disable-next-line no-nested-ternary
    const hour = i === 12 ? '12' : i > 12 ? '0' + (i - 12) : '0' + i
    for (let j = 0; j < minuteIncrement; j++) {
      const time = {
        value: ('0' + i).slice(-2) + ('0' + j * minIncrementProp).slice(-2),
        HH: ('0' + i).slice(-2),
        MM: ('0' + j * minIncrementProp).slice(-2),
        hh: i === 0 ? '12' : hour.slice(-2),
        mm: ('0' + j * minIncrementProp).slice(-2),
        active: true,
        period: i >= 12 ? 'PM' : 'AM',
      }
      timeArray.push(time)
    }
  }
  return timeArray
}

function calculateRoundedTimeValue(curMoment, minIncrementProp) {
  // If we receive a moment value, find nearest time increment
  const roundedTime =
    Math.round(
      (curMoment.hour() * 60 + curMoment.minute()) / minIncrementProp
    ) * minIncrementProp
  return (
    ('0' + Math.floor(roundedTime / 60)).slice(-2) +
    ('0' + (roundedTime % 60)).slice(-2)
  )
}

export function generateTimeObjects({
  startMoment,
  endMoment,
  minuteIncrement,
  sameIsValid,
  equalTimeError,
  endTimeError,
}) {
  let startTimeMoment
  let endTimeMoment
  let error

  const startMomentObject = dayjs(startMoment)
  const endMomentObject = dayjs(endMoment)

  // Check if two moment objects are valid
  if (validMoments(startMomentObject, endMomentObject)) {
    startTimeMoment = dayjs(startMomentObject).second(0)
    endTimeMoment = dayjs(endMomentObject).second(0)
  } else {
    startTimeMoment = dayjs().hour(8)
    endTimeMoment = dayjs().hour(10)
  }
  const startTimeValue = calculateRoundedTimeValue(
    startTimeMoment,
    minuteIncrement
  )
  const endTimeValue = calculateRoundedTimeValue(endTimeMoment, minuteIncrement)

  const startHour = parseInt(startTimeValue.substring(0, 2), 10)
  const endHour = parseInt(endTimeValue.substring(0, 2), 10)
  // Set our moment objects hours and minutes to the rounded time value
  dayjs(startMomentObject)
    .hour(startHour > 23 ? 23 : startHour)
    .minute(startHour > 23 ? 59 : parseInt(startTimeValue.substring(2, 4), 10))
    .second(0)
  dayjs(endMomentObject)
    .hour(endHour > 23 ? 23 : endHour)
    .minute(endHour > 23 ? 59 : parseInt(endTimeValue.substring(2, 4), 10))
    .second(0)

  // Confirm if start and end times are valid ranges
  const validity = validRange(startTimeMoment, endTimeMoment, sameIsValid)
  if (!sameIsValid) {
    if (validity === 'equal') {
      error = equalTimeError
    } else if (validity === 'greater') {
      error = endTimeError
    } else {
      error = null
    }
  } else if (validity === 'greater') {
    error = endTimeError
  }

  // Calculate time increments
  const startTimeIncrement = generateTimeIncrement(minuteIncrement)
  const endTimeIncrement = generateTimeIncrement(minuteIncrement)

  // Return times back to the select object
  return {
    startTimeIncrement,
    endTimeIncrement,
    startTimeValue,
    endTimeValue,
    error,
  }
}

export function manipulateTimeObject(momentObject, newTimeValue) {
  const hour = parseInt(newTimeValue.substring(0, 2), 10)
  const time = dayjs(momentObject)
    .set('hour', hour > 23 ? 23 : hour)
    .set('minute', hour > 23 ? 59 : parseInt(newTimeValue.substring(2, 4), 10))
    .set('second', 0)
  return time.toISOString()
}
